export enum CoursePermissions {
    courseUpdate = "course: update"
}
